import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTheme } from '../context/ThemeContext';

function InvoiceHistory() {
  const { darkMode } = useTheme();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      const response = await axios.get('/api/stripe-checkout/invoices');
      setInvoices(response.data.invoices);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load invoice history');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatAmount = (amount, currency) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase()
    }).format(amount / 100);
  };

  const getStatusBadge = (status) => {
    const styles = {
      paid: { bg: '#dcfce7', color: '#166534', text: 'Paid' },
      open: { bg: '#dbeafe', color: '#1e40af', text: 'Open' },
    };
    const style = styles[status] || styles.open;
    return <span style={{ padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', backgroundColor: style.bg, color: style.color }}>{style.text}</span>;
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div>
      <div className="content-header">
        <h1>Invoice History <span style={{ marginLeft: "12px", padding: "4px 12px", backgroundColor: "#3b82f6", color: "white", fontSize: "14px", fontWeight: "600", borderRadius: "6px" }}>NEW</span></h1>
        <p style={{ color: '#6b7280' }}>View and download your past invoices</p>
      </div>
      <div className="content-body">
        {error && <div style={{ padding: '12px', background: '#fecaca', color: '#991b1b', borderRadius: '6px' }}>{error}</div>}
        {invoices.length === 0 ? (
          <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '40px' }}><p>No invoices found</p></div></div>
        ) : (
          <div className="card"><div className="card-body" style={{ padding: 0 }}><p>Invoice table here</p></div></div>
        )}
      </div>
    </div>
  );
}

export default InvoiceHistory;
